import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import HAttachment from "../../../src/common/components/attachment.vue";
let BigAttachment = class BigAttachment extends Vue {
    constructor() {
        super(...arguments);
        this.displayTemplate = false;
    }
    controlChange(val) {
        this.displayTemplate = this.control.options.displayTemplate || false;
    }
    render(h) {
        console.log(this.control, 'control');
        const that = this;
        return h('h-attachment', {
            props: {
                disabled: true,
                text: that.$t('cloudpivot.form.dataitem.ClickOrDragUpload').toString(),
                displayTemplate: this.displayTemplate,
            }
        });
    }
};
tslib_1.__decorate([
    Prop()
], BigAttachment.prototype, "control", void 0);
tslib_1.__decorate([
    Watch('control', {
        immediate: true,
        deep: true
    })
], BigAttachment.prototype, "controlChange", null);
BigAttachment = tslib_1.__decorate([
    Component({ name: 'BigAttachment', components: { HAttachment } })
], BigAttachment);
export default BigAttachment;
